import React from 'react';
import cn from '@/utils/cn';

const selectClass = cn(
  'tw-bg-spa-bg-secondary tw-border tw-border-solid tw-border-spa-border tw-rounded',
  'tw-px-2 tw-py-1.5 tw-text-sm tw-text-spa-on-bg tw-cursor-pointer tw-box-border',
  'focus:tw-outline-none focus:tw-border-spa-accent',
);

interface LoadingStatusBarProps {
  isFullyLoaded: boolean;
  loadedCount: number;
  onPageSizeChange: (size: number) => void;
  pageSize: number;
  pageSizeOptions: number[];
  totalCount: number;
}

const LoadingStatusBar = ({
  isFullyLoaded,
  loadedCount,
  onPageSizeChange,
  pageSize,
  pageSizeOptions,
  totalCount,
}: LoadingStatusBarProps) => {
  const statusText = isFullyLoaded ? `${loadedCount} results` : `Loaded ${loadedCount} of ${totalCount} results`;

  return (
    <div className="tw-flex tw-items-center tw-gap-4">
      <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-spa-secondary">
        {!isFullyLoaded && (
          <span
            aria-label="Loading results"
            className={cn(
              'tw-inline-block tw-w-4 tw-h-4 tw-border-2 tw-border-solid',
              'tw-border-spa-tertiary tw-border-t-spa-accent tw-rounded-full tw-animate-spin',
            )}
            role="status"
          />
        )}
        <span>
          {statusText}
        </span>
      </div>
      <select
        className={selectClass}
        value={pageSize}
        onChange={e => onPageSizeChange(Number(e.target.value))}
      >
        {pageSizeOptions.map(size => (
          <option key={size} value={size}>
            {size} per page
          </option>
        ))}
      </select>
    </div>
  );
};

export default LoadingStatusBar;
